/* Apex FlexStand page behaviours (ported from the Ascartes / Gymshark PDP build).
   Loaded only by the apex-asc-* sections. Add-to-cart itself is handled by the theme's
   <product-form-component>; this file only keeps the variant picker, price, gallery,
   promo copy, save-for-later, share, tabs, lazy video and the reviews list in sync. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, minimumFractionDigits: 2 }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  function toast(msg) {
    var t = document.getElementById('asc-toast');
    if (!t) { t = document.createElement('div'); t.id = 'asc-toast'; t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;left:50%;bottom:2rem;transform:translateX(-50%);background:#0d1012;color:#fff;padding:10px 16px;font:700 14px/1.4 Roboto,Arial,sans-serif;z-index:99;opacity:0;transition:opacity .2s';
      document.body.appendChild(t); }
    t.textContent = msg; t.style.opacity = '1';
    clearTimeout(toast.t); toast.t = setTimeout(function () { t.style.opacity = '0'; }, 2200);
  }

  /* header height → sticky offset */
  function headerH() {
    var h = $('#header-component, .header-wrapper, .shopify-section-header, header');
    if (h) document.documentElement.style.setProperty('--asc-header-h', h.getBoundingClientRect().height + 'px');
  }
  headerH(); window.addEventListener('resize', headerH);

  /* ---------- buy box ---------- */
  var pdp = $('[data-asc-pdp]');
  if (pdp) {
    var opts = $$('.asc-pdp__size', pdp), idInput = $('[data-variant-id]', pdp), form = $('form', pdp);
    var priceEl = $('[data-price]', pdp), err = $('[data-size-error]', pdp), label = $('[data-opt-label]', pdp);
    var addBtn = $('.asc-pdp__add', pdp), addTxt = addBtn && addBtn.querySelector('.add-to-cart-text');
    var addLabel = addTxt ? addTxt.textContent.trim() : 'Add to bag';
    var dot = $('[data-stock-dot]', pdp), stockTxt = $('[data-stock-text]', pdp);
    var chosen = opts.length === 0 || opts.some(function (b) { return b.classList.contains('is-selected'); });

    opts.forEach(function (b) {
      b.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-selected'); b.setAttribute('aria-checked', 'true');
        chosen = true; if (err) err.hidden = true;
        idInput.value = b.dataset.variant;
        if (label) label.textContent = b.dataset.name;
        var p = parseInt(b.dataset.price, 10), c = parseInt(b.dataset.compare, 10) || 0;
        if (priceEl) priceEl.innerHTML = c > p
          ? '<s>' + money(c) + '</s> <span class="asc-pdp__price--sale">' + money(p) + '</span><span class="asc-pdp__save">Save ' + money(c - p) + '</span>'
          : money(p);
        var avail = b.dataset.available === 'true';
        if (addBtn) { addBtn.disabled = !avail; if (addTxt) addTxt.textContent = avail ? addLabel : 'Sold out'; }
        if (dot) dot.classList.toggle('is-out', !avail);
        if (stockTxt) stockTxt.textContent = avail ? 'In stock — ships within 24 hours' : 'Currently unavailable';
        /* scroll the gallery to the variant's photo */
        if (b.dataset.mediaId && window.apxAscGo) window.apxAscGo(b.dataset.mediaId);
        try { history.replaceState(null, '', location.pathname + '?variant=' + b.dataset.variant); } catch (e) {}
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!chosen) {
          e.preventDefault(); e.stopImmediatePropagation();
          if (err) err.hidden = false;
          var grid = $('[data-sizes]', pdp); if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    /* promo code copy */
    var code = $('[data-copy]', pdp);
    if (code) code.addEventListener('click', function () {
      var st = $('[data-copy-state]', code);
      var done = function () { if (st) { st.textContent = 'Copied'; setTimeout(function () { st.textContent = 'Copy'; }, 1800); } toast('Code copied — apply it at checkout'); };
      if (navigator.clipboard) navigator.clipboard.writeText(code.dataset.copy).then(done, done); else done();
    });

    /* save for later (local) */
    var wish = $('[data-wish]', pdp), handle = pdp.dataset.handle, KEY = 'apex_saved';
    function wishList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    if (wish) {
      if (wishList().indexOf(handle) > -1) wish.classList.add('is-on');
      wish.addEventListener('click', function () {
        var l = wishList(), i = l.indexOf(handle);
        if (i > -1) { l.splice(i, 1); wish.classList.remove('is-on'); } else { l.push(handle); wish.classList.add('is-on'); toast('Saved for later'); }
        try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {}
      });
    }

    /* share */
    var share = $('[data-share]', pdp);
    if (share) share.addEventListener('click', function () {
      var data = { title: share.dataset.title, url: share.dataset.url };
      if (navigator.share) { navigator.share(data).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { toast('Link copied'); }); }
    });
  }

  /* ---------- gallery: sliding strip + thumbs ---------- */
  var gal = $('[data-gallery]');
  if (gal) {
    var main = $('[data-main]', gal), slides = $$('.asc-pdp__media', gal), thumbs = $$('[data-thumb]', gal), count = $('[data-count]', gal), cur = 0;
    var loadImg = function (sl) { var im = sl && sl.querySelector('img[data-src]'); if (im) { im.src = im.dataset.src; im.srcset = im.dataset.srcset || ''; im.removeAttribute('data-src'); } };
    var mark = function (i) {
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', String(k === i)); if (k === i && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); });
      loadImg(slides[i]); loadImg(slides[i + 1]); loadImg(slides[i - 1]);
      if (count) count.textContent = i + 1;
      var v = slides[i] && slides[i].querySelector('video'); if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    };
    var go = function (i) {
      if (!slides.length || !main) return; i = (i + slides.length) % slides.length;
      loadImg(slides[i]);
      main.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      mark(i);
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
    $$('[data-nav]', gal).forEach(function (b) { b.addEventListener('click', function () { go(cur + (+b.dataset.nav)); }); });
    if (main) {
      var st;
      main.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { var i = Math.round(main.scrollLeft / main.clientWidth); if (i !== cur && slides[i]) mark(i); }, 80);
      }, { passive: true });
    }
    setTimeout(function () { loadImg(slides[1]); }, 1200);
    window.apxAscGo = function (mediaId) { var k = slides.findIndex(function (sl) { return sl.dataset.mediaId === mediaId; }); if (k > -1) go(k); };
  }

  /* ---------- tabs (product tabs + review dimensions) ---------- */
  $$('[data-asc-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root), panels = $$('[role="tabpanel"]', root);
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, k) { x.classList.toggle('is-active', k === i); x.setAttribute('aria-selected', String(k === i)); });
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
      });
    });
  });

  /* ---------- lazy video: play on sight, pause off-screen ---------- */
  var vids = $$('video.asc-lazyvid');
  if (vids.length) {
    var small = window.matchMedia('(max-width: 749px)').matches;
    var conn = navigator.connection || {};
    var slow = !!conn.saveData || /(^|[^\d])2g/.test(conn.effectiveType || '');
    var attach = function (v) {
      if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster;
      if (v.dataset.loaded) return;
      v.dataset.loaded = '1';
      if (v.dataset.lazy === 'url') {
        var src = (small || slow) ? (v.dataset.srcSd || v.dataset.srcHd) : (v.dataset.srcHd || v.dataset.srcSd);
        if (!src) return;
        var s = document.createElement('source'); s.src = src; s.type = 'video/mp4'; v.appendChild(s);
      }
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.load();
    };
    var play = function (v) { attach(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    var pause = function (v) { if (!v.paused) v.pause(); };
    if (!('IntersectionObserver' in window)) { vids.forEach(play); }
    else {
      var near = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) attach(e.target); }); }, { rootMargin: '600px 0px', threshold: 0 });
      var vis = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) play(e.target); else pause(e.target); }); }, { threshold: 0.2 });
      vids.forEach(function (v) { near.observe(v); vis.observe(v); });
    }
    document.addEventListener('visibilitychange', function () { vids.forEach(function (v) { if (document.hidden) pause(v); }); });
  }
  $$('[data-asc-video]').forEach(function (root) {
    var v = root.querySelector('video'), b = root.querySelector('[data-pause]'); if (!v || !b) return;
    b.addEventListener('click', function () {
      var paused = v.paused; if (paused) v.play(); else v.pause();
      b.setAttribute('aria-pressed', String(!paused));
      b.innerHTML = paused
        ? '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5l12 7-12 7z"/></svg>';
    });
  });

  /* ---------- reviews ---------- */
  var rv = $('[data-asc-reviews]');
  if (rv) {
    var items = $$('.asc-rv__item', rv), list = $('[data-list]', rv), per = parseInt(rv.dataset.per, 10) || 5, shown = per;
    var search = $('[data-search]', rv), sortSel = $('[data-sort]', rv), filters = $$('[data-f]', rv);
    var moreBtn = $('[data-more-btn]', rv), shownEl = $('[data-shown]', rv), totalEl = $('[data-total]', rv), empty = $('[data-empty]', rv);
    var snaps = $$('[data-filter-rating]', rv), ratingSel = $('[data-f="rating"]', rv);

    $$('[data-ago]', rv).forEach(function (t) {
      var d = new Date(t.getAttribute('datetime')); if (isNaN(d)) return;
      var days = Math.floor((Date.now() - d.getTime()) / 864e5), s;
      if (days < 1) s = 'today'; else if (days < 30) s = days + (days === 1 ? ' day ago' : ' days ago');
      else if (days < 365) { var m = Math.floor(days / 30); s = m + (m === 1 ? ' month ago' : ' months ago'); }
      else { var y = Math.floor(days / 365); s = y + (y === 1 ? ' year ago' : ' years ago'); }
      t.textContent = s;
    });

    function apply() {
      if (!list) return;
      var q = (search && search.value || '').trim().toLowerCase();
      var f = {}; filters.forEach(function (s) { f[s.dataset.f] = s.value; });
      var vis = items.filter(function (it) {
        if (q && it.textContent.toLowerCase().indexOf(q) === -1) return false;
        for (var k in f) { if (f[k] && String(it.dataset[k] || '') !== f[k]) return false; }
        return true;
      });
      var mode = sortSel ? sortSel.value : 'recent';
      vis.sort(function (a, b) {
        var ra = +a.dataset.rating, rb = +b.dataset.rating, ia = +a.dataset.i, ib = +b.dataset.i;
        if (mode === 'rated') return rb - ra || ia - ib;
        if (mode === 'lowest') return ra - rb || ia - ib;
        if (mode === 'helpful') return (+b.dataset.helpful) - (+a.dataset.helpful) || ia - ib;
        return ((+b.dataset.ts) || 0) - ((+a.dataset.ts) || 0) || ia - ib;
      });
      items.forEach(function (it) { it.classList.add('is-hidden'); });
      vis.forEach(function (it, k) { list.appendChild(it); if (k < shown) it.classList.remove('is-hidden'); });
      var n = Math.min(shown, vis.length);
      if (shownEl) shownEl.textContent = vis.length ? '1-' + n : '0';
      if (totalEl) totalEl.textContent = vis.length;
      if (moreBtn) moreBtn.hidden = vis.length <= shown;
      if (empty) empty.hidden = vis.length > 0;
      snaps.forEach(function (s) { s.classList.toggle('is-active', ratingSel && ratingSel.value === s.dataset.filterRating); });
    }
    function reset() { shown = per; apply(); }
    if (search) search.addEventListener('input', reset);
    if (sortSel) sortSel.addEventListener('change', reset);
    filters.forEach(function (s) { s.addEventListener('change', reset); });
    snaps.forEach(function (s) { s.addEventListener('click', function () {
      if (!ratingSel) return;
      ratingSel.value = ratingSel.value === s.dataset.filterRating ? '' : s.dataset.filterRating; reset();
    }); });
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += per; apply(); });

    $$('[data-vote]', rv).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-on')) return;
        var wrap = b.parentNode; $$('[data-vote]', wrap).forEach(function (x) { if (x.classList.contains('is-on')) { x.classList.remove('is-on'); x.querySelector('span').textContent = +x.querySelector('span').textContent - 1; } });
        b.classList.add('is-on'); var n = b.querySelector('span'); n.textContent = +n.textContent + 1;
        var it = b.closest('.asc-rv__item'); if (it && b.dataset.vote === 'up') it.dataset.helpful = +it.dataset.helpful + 1;
      });
    });
    if (items.length) apply();
  }
})();
